/* ======================================================================
   FREIGHT + SUGGESTIONS  ⚠️  THE RATE MODEL HERE IS A PLACEHOLDER
   The weight brackets below are invented for the prototype.
   Replace with live Shipduo rates. The suggestion logic is real and stays.
   ====================================================================== */

/* ── freight: LTL weight breaks (placeholder for the Shipduo rate call) ── */
var BREAKS = [
  {min:0,    rate:0.860},
  {min:1000, rate:0.780},
  {min:1700, rate:0.765},
  {min:2500, rate:0.720}
];
function rateFor(w){ var r=BREAKS[0].rate; BREAKS.forEach(function(b){ if(w>=b.min) r=b.rate }); return r }
function nextBreak(w){ for(var i=0;i<BREAKS.length;i++){ if(BREAKS[i].min>w) return BREAKS[i] } return null }

/* ── everything below is derived from the REAL packer, not an estimate ── */
var ENVELOPE = RULES.W * RULES.L * RULES.maxH;
function metrics(list){
  var res = packAuto(cartLines(list), RULES);
  var live = res.pallets.filter(function(p){ return p.cases>0 });
  var cases=0, weight=0, boxVol=0;
  live.forEach(function(p){
    cases += p.cases; weight += p.weight;
    p.boxes.forEach(function(b){ boxVol += b.w*b.l*b.h });
  });
  var subtotal = (list||items).reduce(function(a,i){ return a + i.price*i.qty }, 0);
  return {
    res:res, live:live, pallets:live.length, cases:cases, weight:weight,
    util: live.length ? boxVol/(live.length*ENVELOPE) : 0,
    subtotal:subtotal, freight: weight ? weight*rateFor(weight) : 0
  };
}
var usd = function(n){ return n.toLocaleString('en-US',{style:'currency',currency:'USD'}) };
var num = function(n){ return n.toLocaleString('en-US') };

/* ── suggestions ─────────────────────────────────────────────────────
   Two different mechanics, both legitimate:
   · ADD  — there is room on a pallet you already pay for, and a few more
            cases cross the next freight bracket.
   · TRIM — the order spills onto a nearly empty extra pallet you are
            charged for in full; dropping a few cases collapses it.
   Trim is only ever offered when it removes a WHOLE pallet. Nibbling at
   an order to save a few dollars helps nobody.
   ------------------------------------------------------------------ */
function addSuggestion(base){
  var nb = nextBreak(base.weight);
  if(!nb || !base.weight) return null;
  var need = nb.min - base.weight, best = null;
  items.forEach(function(it){
    var n = Math.max(1, Math.ceil(need/it.wt));
    var trial = items.map(function(x){ return x.sku===it.sku ? Object.assign({},x,{qty:x.qty+n}) : x });
    var after = metrics(trial);
    if(after.pallets > base.pallets) return;
    var saving = base.freight - after.freight;
    if(saving <= 0) return;
    var cost = it.price*n, net = saving - cost;
    if(!best || net > best.net) best = {kind:'add', item:it, n:n, saving:saving, cost:cost, net:net};
  });
  return best;
}

function trimSuggestion(base){
  if(base.pallets < 2) return null;
  var idx = 0, least = Infinity;
  base.live.forEach(function(p,i){ if(p.cases < least){ least = p.cases; idx = i } });
  var target = base.live[idx];
  if(!target.cases) return null;

  var cuts = {};
  target.boxes.forEach(function(b){ cuts[b.sku] = (cuts[b.sku]||0) + 1 });
  var trial = items.map(function(x){
    return Object.assign({}, x, {qty: Math.max(0, x.qty - (cuts[x.sku]||0))});
  });
  var after = metrics(trial);
  if(after.pallets >= base.pallets) return null;

  var saving = base.freight - after.freight;
  if(saving <= 0) return null;

  var vol = target.boxes.reduce(function(a,b){ return a + b.w*b.l*b.h }, 0);
  var names = items.filter(function(x){ return cuts[x.sku] })
                   .map(function(x){ return cuts[x.sku] + ' × ' + x.name });
  return {
    kind:'trim', cuts:cuts, n:target.cases, saving:saving, names:names,
    value: items.reduce(function(a,x){ return a + (cuts[x.sku]||0)*x.price }, 0),
    fill: Math.round(vol/ENVELOPE*100),
    palletNo: idx + 1
  };
}

/* Order matters. "Add" is a Pareto improvement — the customer receives MORE
   goods and pays LESS freight, so nobody loses. "Trim" is a trade-off: cheaper,
   but they go home with less. Lead with the win-win, offer the trade-off second,
   even when trim saves more on paper. */
function suggestions(base){
  return [addSuggestion(base), trimSuggestion(base)].filter(Boolean);
}
